import axios from "../axiosPlugin.js";

export const getCinemaList = () => {
  return axios({
    url: "/api/cinema/list?page=0&pageSize=9999",
    method: "get",
    data: {},
  });
};

export const getDailyClosingDetail = id => {
  return axios({
    url: `/api/dayClose/detail/${id}`,
    method: "get",
    data: {},
  });
};

//dailyClosing.vue
export const getDailyClosingList = data => {
  return axios({
    url: "/api/dayClose/list",
    method: "get",
    data: { data },
  });
};


// createDailyClosing dialog - 対象レジ（シフト）の選択
export const getDailyClosingShiftList = (data, loading = true, isDefaultAlertTips = true) => {
  return axios({
    url: "/api/dayClose/shiftList",
    method: "get",
    data: {
      data,
      loading,
      isDefaultAlertTips,
    },
  });
};

// createDailyClosing dialog - 売掛金現金回収の登録
export const getDailyClosingSellList = data => {
  return axios({
    url: "/api/dayClose/sellList",
    method: "get",
    data: { data },
  });
};

// createDailyClosing dialog - 買掛金現金支払の登録
export const getDailyClosingPayment = data => {
  return axios({
    url: "/api/dayClose/paymentList",
    method: "get",
    data: { data },
  });
};

// createDailyClosing dialog - その他仕入の現金支払の登録
export const getOtherGoods = cinemaId => {
  return axios({
    url: "/api/otherGoods/list?page=0&pageSize=9999&cinemaId=" + cinemaId,
    method: "get",
    data: {},
  });
};

//CreateDailyClosingDialog - next button
export const submitDailyClosingBasic = data => {
  return axios({
    url: "/api/dayClose/basic",
    method: "post",
    data: { data }
  });
};

//cashTable Dialog - deposit
export const getDeposit = () => {
  return axios({
    url: "/api/bankAccount/list?page=0&pageSize=9999",
    method: "get",
    data: {},
  });
};

//cashTable Dialog - Next Button
export const updateDayCloseCash = data => {
  return axios({
    url: "/api/dayClose/cash",
    method: "post",
    data: { data },
  });
};

// AccountsReceivableTable dialog -  その他営業収入の売掛金登録 - 品目名
export const getOtherRevenueList = cinemaId => {
  return axios({
    url: "/api/otherRevenue/list?page=0&pageSize=9999&cinemaId=" + cinemaId,
    method: "get",
    data: {},
  });
};

// AccountsReceivableTable dialog - 売掛金 売掛金名list
export const getDailyClosingReceivable = (data, loading = false, isDefaultAlertTips = true) => {
  return axios({
    url: "/api/dayClose/getReceivable",
    method: "get",
    data: {
      data,
      loading,
      isDefaultAlertTips,
    }
  });
};

// AccountsReceivableTable dialog - next button
export const updateDayCloseAccountReceivable = data => {
  return axios({
    url: "/api/dayClose/receivable",
    method: "post",
    data: { data },
  });
};

// TheaterAdvanceTicketTableDialog dialog - next button - save
export const saveDayClose = (data, loading = true, isDefaultAlertTips = true) => {
  return axios({
    url: "/api/dayClose/save",
    method: "post",
    data: {
      data,
      loading,
      isDefaultAlertTips,
    }
  });
};

export const approveDailyClosing = (data, loading = true, isDefaultAlertTips = true) => {
  const _data = Object.keys(data).map(key => `${key}=${data[key]}`).join("&");

  return axios({
    url: `/api/dayClose/approve?${_data}`,
    method: "put",
    data: {
      data,
      loading,
      isDefaultAlertTips,
    }
  });
};

export const deleteDailyClosing = (data, loading = true) => {
  return axios({
    url: "/api/dayClose/delete/" + data.id,
    method: "delete",
    data: {
      loading,
    }
  });
};

export const getAccountPayablePaymentList = (brandId, accountPayableId) => {
  return axios({
    url: "/api/AccountPayablePayment/list?page=0&pageSize=9999&brandId=" + brandId + "&accountPayableId=" + accountPayableId,
    method: "get",
    data: {},
  });
};
